import { useEventDetails } from 'src/context';

/** True when the event has at least one map record (map imagery / layout). */
export function useEventHasMap(eventId: string | undefined) {
    const { event, isLoading } = useEventDetails(eventId);
    const hasMap = (event?.maps?.length ?? 0) > 0;
    return { hasMap, isLoading };
}
